import { compose } from 'recompose';

import ProgressBar from './progressBar';

const enhance = compose(
);
export default enhance(ProgressBar);
